export function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <span className="span">Copyright © 2026 怀远模玩文化有限公司</span>
        <div className="link">
          {/* <a href="https://beian.mps.gov.cn/#/query/webSearch" rel="noreferrer" target="_blank">
            <span className="icon">
              <img src="/image/1.jpg" />
            </span>
            <span>粤公网安备44011102484763号</span>
          </a> */}
          <a href="https://beian.miit.gov.cn/" target="_blank">
            <span>皖ICP备2026016054号-1</span>
          </a>
        </div>
      </div>
    </footer>
  );
}
